module.exports = __webpack_public_path__ + "media/img/avatars/products/product-4-d6d284cb7ef95bd69796b040818ccb44.jpg";